
class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.inputQuery = this.querySelector('#main-search-input-query');

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('q')) {
      this.inputQuery.value = this.sanitizeInputValue(urlParams.get('q'));
    }
  }

  sanitizeInputValue(value) {
    const regexResult = value.match(/\*>(.*)<\*/);
    if (regexResult) {
      return regexResult[1];
    }
    return value;
  }
}

customElements.define('main-search', MainSearch);